module.exports = __webpack_public_path__ + "static/media/customerServiceimg2.a4a722ca.png";